import {
  CostForecastListEntry,
  PriceForecastListEntry,
} from '../../../../core/clients/omni-core/models';

export type PriceTableView = 'PRICE' | 'FORECAST';

export type PriceForecastComponent = PriceForecastListEntry & { type: 'PRICE' };
export type CostForecastComponent = CostForecastListEntry & { type: 'COST' };

export const toPriceComponent = (entry: PriceForecastListEntry): PriceForecastComponent => ({
  ...entry,
  type: 'PRICE',
});
export const toCostComponent = (entry: CostForecastListEntry): CostForecastComponent => ({
  ...entry,
  type: 'COST',
});
